export const filters = {
  ALERT_PAGE: [
    {
      name: 'ALERT_TYPE',
      actualName: 'Alert Type',
      sortOrder: 1,
      key: 1,
      pageName: 'ALERT_PAGE',
      default: false,
      type: 'CHECKBOXES',
    },
    {
      name: 'APPLICATION',
      actualName: 'Application',
      sortOrder: 2,
      key: 2,
      default: false,
      pageName: 'ALERT_PAGE',
      type: 'DROP_DOWN_WITH_FILTER',
    },
    {
      name: 'PRIORITY',
      actualName: 'Priority',
      sortOrder: 3,
      key: 3,
      default: false,
      pageName: 'ALERT_PAGE',
      type: 'CHECKBOXES',
    },
    {
      name: 'RESOURCE_GROUP',
      actualName: 'Resource Group',
      sortOrder: 4,
      key: 4,
      default: false,
      pageName: 'ALERT_PAGE',
      type: 'DROP_DOWN_WITH_FILTER',
    },
    {
      name: 'BUSINESS_FUNCTION',
      actualName: 'Business Function',
      sortOrder: 5,
      key: 5,
      default: false,
      pageName: 'ALERT_PAGE',
      type: 'DROP_DOWN_WITH_FILTER',
    },
    {
      name: 'NAME_SPACE',
      actualName: 'Namespace',
      sortOrder: 5,
      key: 6,
      default: false,
      pageName: 'ALERT_PAGE',
      type: 'DROP_DOWN_WITH_FILTER',
    },
  ],
  ADMIN_PAGE: [
    {
      name: 'TABLES',
      actualName: 'Tables',
      sortOrder: 2,
      key: 7,
      pageName: 'ADMIN_PAGE',
      default: false,
      type: 'DROP_DOWN',
    },
  ],
  RESOURCE_PAGE: [
    {
      name: 'ALL_RESOURCES',
      actualName: 'All Resources',
      sortOrder: 3,
      key: 7,
      default: false,
      pageName: 'RESOURCE_PAGE',
      type: 'SINGLECHECKBOX',
    },
    {
      name: 'APPLICATION',
      actualName: 'Application',
      sortOrder: 2,
      key: 8,
      default: false,
      pageName: 'RESOURCE_PAGE',
      type: 'DROP_DOWN_WITH_FILTER',
    },
    {
      name: 'BUSINESS_FUNCTION',
      actualName: 'Business Function',
      sortOrder: 3,
      key: 9,
      default: false,
      pageName: 'RESOURCE_PAGE',
      type: 'DROP_DOWN_WITH_FILTER',
    },
    {
      name: 'NAME_SPACE',
      actualName: 'Namespace',
      sortOrder: 4,
      key: 10,
      default: false,
      pageName: 'RESOURCE_PAGE',
      type: 'DROP_DOWN_WITH_FILTER',
    },
    {
      name: 'RESOURCE_GROUP',
      actualName: 'Resource Group',
      sortOrder: 5,
      key: 11,
      pageName: 'RESOURCE_PAGE',
      default: false,
      type: 'DROP_DOWN_WITH_FILTER',
    },
  ],
  RELEASE_LIST_PAGE: [
    {
      name: 'RELEASE_STATUS',
      actualName: 'Release Status',
      sortOrder: 0,
      key: 12,
      default: false,
      pageName: 'RELEASE_PAGE',
      type: 'RELEASE_STATUS_CHECKBOXES',
    },
    {
      name: 'RELEASE_DATES',
      actualName: 'Release Dates',
      sortOrder: 1,
      key: 13,
      default: false,
      pageName: 'RELEASE_PAGE',
      type: 'RELEASE_DATES_CHECKBOXES',
    },
    {
      name: 'ARCHIVE_STATUS',
      actualName: 'Archive Status',
      sortOrder: 3,
      key: 14,
      default: false,
      pageName: 'RELEASE_PAGE',
      type: 'ARCHIVE_STATUS_CHECKBOXES',
    },
    {
      name: 'JIRA_PROJECT',
      actualName: 'Jira Project',
      sortOrder: 4,
      key: 15,
      default: false,
      pageName: 'RELEASE_PAGE',
      type: 'DROP_DOWN_WITH_FILTER',
    },
    {
      name: 'RELEASE_APPLICATION',
      actualName: 'Application',
      sortOrder: 5,
      key: 16,
      pageName: 'RELEASE_PAGE',
      default: false,
      type: 'DROP_DOWN_WITH_FILTER',
    },
    {
      name: 'CREATED_BY',
      actualName: 'Created By',
      sortOrder: 5,
      key: 17,
      pageName: 'RELEASE_PAGE',
      default: false,
      type: 'DROP_DOWN_WITH_FILTER',
    },
  ],
  RELEASE_CALENDAR_PAGE: [
    {
      name: 'RELEASE_STATUS',
      actualName: 'Release Status',
      sortOrder: 0,
      key: 12,
      default: false,
      pageName: 'RELEASE_CALENDAR_PAGE',
      type: 'RELEASE_STATUS_CHECKBOXES',
    },
    {
      name: 'RELEASE_DATES',
      actualName: 'Release Dates',
      sortOrder: 1,
      key: 13,
      default: false,
      pageName: 'RELEASE_CALENDAR_PAGE',
      type: 'RELEASE_DATES_CHECKBOXES',
    },
    {
      name: 'ARCHIVE_STATUS',
      actualName: 'Archive Status',
      sortOrder: 3,
      key: 14,
      default: false,
      pageName: 'RELEASE_CALENDAR_PAGE',
      type: 'ARCHIVE_STATUS_CHECKBOXES',
    },
    {
      name: 'JIRA_PROJECT',
      actualName: 'Jira Project',
      sortOrder: 4,
      key: 15,
      default: false,
      pageName: 'RELEASE_CALENDAR_PAGE',
      type: 'DROP_DOWN_WITH_FILTER',
    },
    {
      name: 'RELEASE_APPLICATION',
      actualName: 'Application',
      sortOrder: 5,
      key: 16,
      pageName: 'RELEASE_CALENDAR_PAGE',
      default: false,
      type: 'DROP_DOWN_WITH_FILTER',
    },
    {
      name: 'CREATED_BY',
      actualName: 'Created By',
      sortOrder: 5,
      key: 17,
      pageName: 'RELEASE_CALENDAR_PAGE',
      default: false,
      type: 'DROP_DOWN_WITH_FILTER',
    },
    {
      name: 'COMPLIANCE_STATUS',
      actualName: 'Compliance Status',
      sortOrder: 6,
      key: 18,
      pageName: 'RELEASE_CALENDAR_PAGE',
      default: false,
      type: 'COMPLIANCE_STATUS_CHECKBOXES',
    },
  ],
};
